<template>
  <pdf-a4-page no-margin :pdf-key="lang" v-for="(fremdleitungPage, key) in getFremdleitungenPages(ba)" :key="key">
    <div class="landingpage-background w-screen h-screen">
      <div class="flex flex-col justify-between" style="height: 1020px">
        <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
        <div class="text-xl md:text-xl font-bold">Fremdleitungen</div>
        <div class="content h-full max-h-full">
          <div class="grid grid-cols-8 justify-items-stretch items-center">
            <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Fremdleitungen</div>
            <div class="text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor">Beschreibung/Eingabewerte</div>
            <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Weitere Eingaben</div>
            <div class="col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Bewertung</div>
          </div>
          <div v-if="fremdleitungPage['fremdleitungen'].length > 0">
            <div
              v-for="(fremdleitung, key) in fremdleitungPage['fremdleitungen']"
              :key="key"
              class="ml-2 mt-2 grid grid-cols-8 justify-items-stretch items-center gap-y-3"
              style="border-style: solid; border-color: var(--white100) var(--white100) var(--white100) rgb(216, 215, 26); border-radius: 5px;"
            >
              <div class="ml-2 text-xs col-span-1">Typ:</div>
              <div class="text-xs text-gray-500 capitalize">
                {{ fremdleitung['typ'] }}
              </div>
              
                <div class="ml-2 text-xs md:text-sm" v-if="fremdleitung['typ'] != 'unbekannt'">Art:</div>
                <div v-if="fremdleitung['art-oberirdisch'] && fremdleitung['typ'] != 'unbekannt'" class="text-xs text-gray-500 col-span-2 capitalize">
                  {{ fremdleitung['art-oberirdisch'] }}
                </div>
                <div v-else-if="fremdleitung['art-unterirdisch'] &&fremdleitung['typ'] != 'unbekannt'" class="text-xs text-gray-500 col-span-2 capitalize">
                  {{ fremdleitung['art-unterirdisch'] }}
                </div>
                <div v-else class="text-xs text-gray-500 col-span-3">&nbsp;
                </div>
              <div class="justify-self-end col-span-3">
                <PdfChip
                  v-if="'plus' === fremdleitung['fremdleitung-bewertung']"
                  color="green"
                  mangel-amount-mode
                  value="1"
                  pdf-mode
                />
                <PdfChip
                  v-if="'o' === fremdleitung['fremdleitung-bewertung']"
                  color="blue"
                  mangel-amount-mode
                  value="1"
                  pdf-mode
                />
                <PdfChip
                  v-if="'minus' === fremdleitung['fremdleitung-bewertung']"
                  color="yellow"
                  mangel-amount-mode
                  value="1"
                  pdf-mode
                />
                <PdfChip
                  v-if="'x' === fremdleitung['fremdleitung-bewertung']"
                  color="red"
                  mangel-amount-mode
                  value="1"
                  pdf-mode
                />
              </div>
              <div v-if="fremdleitung['betreiber-bekannt']" class="text-xs col-span-2">
                <span class="ml-2 text-xs text-gray-500">{{ '\u{2611}' }}</span>
                Betreiber bekannt
              </div>
              <div v-else class="ml-2 text-xs col-span-2">
                <span class="text-xs text-gray-500">{{ '\u{2610}' }}</span>
                Betreiber unbekannt
              </div>
              <div class="text-xs text-gray-500 col-span-5">
                {{ fremdleitung['betreiber'] }}
              </div>
              <div class="ml-2 text-xs col-span-2">Betroffene Fläche:</div>
              <div class="ml-2 text-xs col-span-2">
               {{ fremdleitung['betroffeneflaechen'] }}
              </div>
            </div>
          </div>
          <div v-else>
            <div class="mt-2 grid grid-cols-8 justify-items-stretch items-center">
              <div class="justify-center items-center col-span-8"
                style="background-color: rgb(235, 239, 240); border-style: solid; border-color: rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240); border-radius: 5px;"
                >
                <p class="text-xs text-center">Keine Fremdleitungen aufgenommen</p>
              </div>
            </div>
          </div>
        </div>
        <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
      </div>
    </div>
  </pdf-a4-page>
</template>

<script lang="ts">
  import useUser from '@/composables/useUser';
  import Bestandsaufnahme from '@/models/ba/Bestandsaufnahme';
  import Immobilie from '@/models/immobilie.model';
  import { defineComponent, PropType } from 'vue';
  import { useI18n } from 'vue-i18n';
  import moment from 'moment';
  import { useIdentifierFrageFinder } from '@/composables/Bestandsaufnahme/useIdentifierFinder';
  import { getPhotoUrl } from '@/utilities/get-media-url';
  import PdfA4Page from '@/components/Pdf/Components/PdfA4Page.vue';
  import PdfChip from '../Components/PdfChip.vue';
  import TngHeader from './PageElements/TngHeader.vue';
  import BeFooter from './PageElements/BeFooter.vue';
  import isVorhandenCharAndLabel from './PageElements/isVorhandenCharAndLabel.vue';
  import BewertungChip from './PageElements/BewertungChip.vue';
  import { Fragenblock } from '@/models/ba/Fragenblock';
  import { useGesamtflaechen } from './PageElements/useGesamtflaechen';

  export default defineComponent({
    name: 'FremdleitungPage',
    components: {
      PdfA4Page,
      PdfChip,
      TngHeader,
      BeFooter,
      isVorhandenCharAndLabel,
      BewertungChip
    },
    props: {
      ba: {
        type: Object as PropType<Bestandsaufnahme>,
        required: true,
      },
      immobilie: {
        type: Object as PropType<Immobilie>,
        required: true,
      },
      lang: {
        type: String,
        default: 'de',
      },
      Fremdleitung: {
        type: Array as PropType<Fragenblock[]>,
        required: false
      }
    },
    setup(props: any) {
      const { t } = useI18n({ useScope: 'global' });
      const uUser = useUser();
      const { getFremdleitungenPages } = useGesamtflaechen();
      return {
        user: uUser.user,
        t,
        useIdentifierFrageFinder,
        moment,
        getPhotoUrl,
        getFremdleitungenPages,
      };
    },
  });
</script>
<style scoped>
  * {
    color: rgb(23, 68, 81);
    font-family: var(--secondaryFont);
  }
  .landingpage-background {
    position: absolute;
    top: 50px;
    left: 50px;
    width: 700px;
    height: 1050px;
    color: var(--black100);
  }
  .content {
    height: 870px;
  }
  .trenner {
    height: 1px;
    border-width: 0;
    color: gray;
    background-color: gray;
  }
</style>